import React from "react";
import { Box, Checkbox, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import PendingIcon from "@mui/icons-material/Pending";

interface StatusFilterProps {
  selectedStatuses: string[];
  onChange: (statuses: string[]) => void;
  showIndexingStatus?: boolean;
}

const StatusFilter: React.FC<StatusFilterProps> = ({
  selectedStatuses,
  onChange,
  showIndexingStatus = true,
}) => {
  const handleToggle = (status: string) => {
    const newStatuses = selectedStatuses.includes(status)
      ? selectedStatuses.filter((s) => s !== status)
      : [...selectedStatuses, status];

    // Ensure at least one checkbox is always checked
    if (newStatuses.length === 0) {
      return;
    }

    onChange(newStatuses);
  };

  return (
    <Box
      sx={{
        p: 2,
        border: "1px solid rgba(255, 255, 255, 0.3)",
        borderRadius: 1,
        background: "rgba(255, 255, 255, 0.05)",
      }}
    >
      <Typography
        variant="body2"
        sx={{
          mb: 2,
          color: "#fff",
          fontStyle: "italic",
        }}
      >
        Select Document Status
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
        }}
      >
        {showIndexingStatus && (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <Checkbox
            checked={selectedStatuses.includes("completed")}
            onChange={() => handleToggle("completed")}
            sx={{ 
              color: "#fff",
              '&.Mui-checked': { color: "#fff" },
              p: 0.5,
            }}
          />
          <CheckCircleIcon sx={{ color: "#4caf50", fontSize: "1.3rem" }} />
          <Typography sx={{ color: "#fff", fontSize: "0.85rem" }}>
            Indexing Completed
          </Typography>
        </Box>
        )}
        
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <Checkbox
            checked={selectedStatuses.includes("inProgress")}
            onChange={() => handleToggle("inProgress")}
            sx={{ 
              color: "#fff",
              '&.Mui-checked': { color: "#fff" },
              p: 0.5,
            }}
          />
          <ErrorIcon sx={{ color: "#2196f3", fontSize: "1.3rem" }} />
          <Typography sx={{ color: "#fff", fontSize: "0.85rem" }}>
            In Progress
          </Typography>
        </Box>
        
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <Checkbox
            checked={selectedStatuses.includes("pending")}
            onChange={() => handleToggle("pending")}
            sx={{ 
              color: "#fff",
              '&.Mui-checked': { color: "#fff" },
              p: 0.5,
            }}
          />
          <PendingIcon sx={{ color: "#ff9800", fontSize: "1.3rem" }} />
          <Typography sx={{ color: "#fff", fontSize: "0.85rem" }}>
            Pending
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default StatusFilter;
